module.exports = __webpack_public_path__ + "static/media/info-mobile.e6145911.svg";